import _isNil from 'lodash/isNil';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import { EMPTY_ARRAY, EMPTY_STRING } from 'commons-ui';

import usePermissionV2 from 'commons-ui/src/permission/usePermission';
import { ACTION, PAGE_NAMES, RESOURCES } from '../../../../constant';
import { USER_STATUSES, USER_FRAUD_STATUSES, USER_STATUS_LABEL, USER_FRAUD_STATUS_LABEL, VIEW_FIELD_KEYS } from '../constants';
import { ACTION_IDS, ACTION_LABELS } from './constants';

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export const makeActionList = (params?: any) => {
	const { keyConfig } = params;
	const { hasPermission: hasPermissionV2 } = usePermissionV2();

	switch (_get(keyConfig, 'name', EMPTY_STRING)) {
		case VIEW_FIELD_KEYS.PHONE_NUMBER:
			return [
				{
					id: ACTION_IDS.VIEW_PHONE,
					label: ACTION_LABELS[ACTION_IDS.VIEW_PHONE],
					isEnabled: ({ keyData }: { keyData: any }) =>
						(_isNil(keyData) || keyData === '-' || (typeof keyData === 'string' && keyData.includes('*'))) &&
						hasPermissionV2({
							configPageName: PAGE_NAMES.userProfile,
							configResourceName: RESOURCES.basicDetails,
							configActionName: ACTION.viewPhone
						})
				}
			];
		case VIEW_FIELD_KEYS.ALTERNATE_PHONE_NUMBER:
			return [
				{
					id: ACTION_IDS.VIEW_ALTERNATE_PHONE,
					label: ACTION_LABELS[ACTION_IDS.VIEW_ALTERNATE_PHONE],
					isEnabled: ({ keyData }: { keyData: any }) =>
						(_isNil(keyData) || keyData === '-' || (typeof keyData === 'string' && keyData.includes('*'))) &&
						hasPermissionV2({
							configPageName: PAGE_NAMES.userProfile,
							configResourceName: RESOURCES.basicDetails,
							configActionName: ACTION.viewPhone
						})
				},
				{
					id: ACTION_IDS.UPDATE_ALTERNATE_PHONE,
					label: ACTION_LABELS[ACTION_IDS.UPDATE_ALTERNATE_PHONE],
					isEnabled: () =>
						hasPermissionV2({
							configPageName: PAGE_NAMES.userProfile,
							configResourceName: RESOURCES.basicDetails,
							configActionName: ACTION.updateAlternatePhoneNumber
						})
				}
			];
		case VIEW_FIELD_KEYS.EMAIL:
			return [
				{
					id: ACTION_IDS.VIEW_EMAIL,
					label: ACTION_LABELS[ACTION_IDS.VIEW_EMAIL],
					isEnabled: ({ keyData }: { keyData: any }) =>
						(_isNil(keyData) || keyData === '-' || (typeof keyData === 'string' && keyData.includes('*'))) &&
						hasPermissionV2({
							configPageName: PAGE_NAMES.userProfile,
							configResourceName: RESOURCES.basicDetails,
							configActionName: ACTION.viewEmail
						})
				}
			];
		case VIEW_FIELD_KEYS.USER_FRAUD_STATUS:
			return [
				{
					id: ACTION_IDS.MARK_USER_FRAUD,
					label: ACTION_LABELS[ACTION_IDS.MARK_USER_FRAUD],
					isEnabled: ({ keyData }: { keyData: any }) =>
						(_isNil(keyData) || keyData === USER_FRAUD_STATUS_LABEL[USER_FRAUD_STATUSES.FAIR]) &&
						hasPermissionV2({
							configPageName: PAGE_NAMES.userProfile,
							configResourceName: RESOURCES.basicDetails,
							configActionName: ACTION.updateUserFraudStatus
						})
				},
				{
					id: ACTION_IDS.UNMARK_USER_FRAUD,
					label: ACTION_LABELS[ACTION_IDS.UNMARK_USER_FRAUD],
					isEnabled: ({ keyData }: { keyData: any }) =>
						!_isEmpty(keyData) &&
						keyData === USER_FRAUD_STATUS_LABEL[USER_FRAUD_STATUSES.FRAUD] &&
						hasPermissionV2({
							configPageName: PAGE_NAMES.userProfile,
							configResourceName: RESOURCES.basicDetails,
							configActionName: ACTION.updateUserFraudStatus
						})
				}
			];
		case VIEW_FIELD_KEYS.USER_STATUS:
			return [
				{
					id: ACTION_IDS.BLOCK_USER,
					label: ACTION_LABELS[ACTION_IDS.BLOCK_USER],
					isEnabled: ({ keyData }: { keyData: any }) =>
						!_isNil(keyData) &&
						!_isEmpty(keyData) &&
						keyData === USER_STATUS_LABEL[USER_STATUSES.UNBLOCKED] &&
						hasPermissionV2({
							configPageName: PAGE_NAMES.userProfile,
							configResourceName: RESOURCES.basicDetails,
							configActionName: ACTION.blockUnblockUser
						})
				},
				{
					id: ACTION_IDS.UNBLOCK_USER,
					label: ACTION_LABELS[ACTION_IDS.UNBLOCK_USER],
					isEnabled: ({ keyData }: { keyData: any }) =>
						!_isNil(keyData) &&
						!_isEmpty(keyData) &&
						keyData === USER_STATUS_LABEL[USER_STATUSES.BLOCKED] &&
						hasPermissionV2({
							configPageName: PAGE_NAMES.userProfile,
							configResourceName: RESOURCES.basicDetails,
							configActionName: ACTION.blockUnblockUser
						})
				}
			];
		case VIEW_FIELD_KEYS.USER_LEVEL:
			return [
				{
					id: ACTION_IDS.USER_LEVEL_UPDATE,
					label: ACTION_LABELS[ACTION_IDS.USER_LEVEL_UPDATE],
					isEnabled: () =>
						hasPermissionV2({
							configPageName: PAGE_NAMES.userProfile,
							configResourceName: RESOURCES.basicDetails,
							configActionName: ACTION.updateUserLevel
						})
				}
			];
		case VIEW_FIELD_KEYS.DOB:
			return [
				{
					id: ACTION_IDS.VIEW_DOB,
					label: ACTION_LABELS[ACTION_IDS.VIEW_DOB],
					isEnabled: ({ keyData }: { keyData: any }) =>
						(_isNil(keyData) || keyData === '-' || (typeof keyData === 'string' && keyData.includes('*'))) &&
						hasPermissionV2({
							configPageName: PAGE_NAMES.userProfile,
							configResourceName: RESOURCES.basicDetails,
							configActionName: ACTION.viewDOB
						})
				}
			];
		case VIEW_FIELD_KEYS.SUBSCRIPTION:
			return [
				{
					id: ACTION_IDS.CANCEL_SUBSCRIPTION,
					label: ACTION_LABELS[ACTION_IDS.CANCEL_SUBSCRIPTION],
					// TODO: REMOVE THIS BYPASS AFTER TESTING - always enabled for testing
					isEnabled: () => true
				}
			];
		default:
			return EMPTY_ARRAY;
	}
};

export default {
	makeActionList
};
